import { useEffect, useState } from 'react'
import { getExperimentClient } from './experimentClient'

// Returns the variant object for a given flag key after fetching.
// If not available, returns null.
const useExperimentVariant = (flagKey, fallbackVariant) => {
  const [variant, setVariant] = useState(null)

  useEffect(() => {
    let mounted = true
    const client = getExperimentClient()
    if (!client || !flagKey) return () => {}

    const fetchAndSet = async () => {
      try {
        await client.fetch()
        if (!mounted) return
        const v = client.variant(flagKey, fallbackVariant)
        setVariant(v || null)
      } catch (e) {
        if (mounted) setVariant(null)
        // eslint-disable-next-line no-console
        console.error('Error fetching experiment variant:', e)
      }
    }
    fetchAndSet()

    return () => { mounted = false }
  }, [flagKey])

  return variant
}

export default useExperimentVariant
